import { useDispatch } from 'react-redux';
import { headerClickEvent } from 'src/areas/product/actions/product';
import { showModal } from 'src/components/modal/actions';
import { PRODUCT_ALERT_MODAL_ID } from 'src/areas/product/constants';
import type { ProductHeaderClickEventType } from 'src/areas/product/actions/types';

export const useOnAction = () => {
  const dispatch = useDispatch();

  return (type: ProductHeaderClickEventType) => {
    dispatch(headerClickEvent(type));
    if (type === 'alert-create') {
      dispatch(showModal(PRODUCT_ALERT_MODAL_ID));
    }
  };
};
